import React, { useEffect } from "react";
import "../styles/cartFlyDot.css";

export default function CartFlyDot({ fromX, fromY, toX, toY, onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 700);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div
      className="cfd-x"
      style={{
        left: fromX,
        top:  fromY,
        "--dx": `${toX - fromX}px`,
      }}
    >
      <div
        className="cfd-y"
        style={{ "--dy": `${toY - fromY}px` }}
      />
    </div>
  );
}
